requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadingUrls: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      loadError: false,
      chooseOptionsError: false,
      openPopupMobile: false,
      isMiniCart: false,
      buttonQuickView: null,
      chooseOptionsTrigger: null,
      focusTraps: {},
      pendingLoad: null,
      activeProductUrl: '',
      getFocusableElements(container) {
        if (!container) return [];

        return Array.from(container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => {
          return !element.disabled
            && element.getAttribute('aria-hidden') !== 'true'
            && (element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0);
        });
      },
      activateFocusTrap(containerReference, initialFocusReference, trapName) {
        const container = typeof containerReference === 'string'
          ? document.getElementById(containerReference)
          : containerReference;
        const initialFocus = typeof initialFocusReference === 'string'
          ? document.getElementById(initialFocusReference)
          : initialFocusReference;

        if (!container) return;
        this.deactivateFocusTrap(trapName);

        const keydown = (event) => {
          if (event.key !== 'Tab') return;

          const focusable = this.getFocusableElements(container);
          if (!focusable.length) {
            event.preventDefault();
            container.focus();
            return;
          }

          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && (document.activeElement === first || document.activeElement === container)) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        };

        container.addEventListener('keydown', keydown);
        this.focusTraps[trapName] = { container, keydown };

        const target = initialFocus || this.getFocusableElements(container)[0] || container;
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      },
      deactivateFocusTrap(trapName) {
        const trap = this.focusTraps[trapName];
        if (!trap) return;
        trap.container.removeEventListener('keydown', trap.keydown);
        delete this.focusTraps[trapName];
      },
      restoreFocus(element) {
        if (!element || !element.isConnected || typeof element.focus !== 'function') return;
        requestAnimationFrame(() => element.focus({ preventScroll: true }));
      },
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      load(url, el, optionId) {
        this.pendingLoad = { url, el, optionId };
        if (this.show) {
          this.loadPending();
        }
        return true;
      },
      renderContent(content) {
        const destination = document.getElementById('quickview-product-content');
        if (!destination) return;

        this.loadError = false;

        const alpine = window.Alpine;
        if (alpine?.mutateDom && alpine?.initTree) {
          destination.replaceChildren();
          alpine.mutateDom(() => {
            destination.innerHTML = content;
            window.SpintzProductPolish?.sort(destination);
          });
          Array.from(destination.children).forEach((child) => alpine.initTree(child));
        } else {
          destination.innerHTML = content;
          window.SpintzProductPolish?.sort(destination);
        }
      },
      loadPending() {
        if (!this.pendingLoad) return false;

        const { url, el, optionId } = this.pendingLoad;
        this.loading = true;
        this.loadError = false;
        if (!this.buttonQuickView) {
          this.buttonQuickView = el;
        }
        let variant = document.getElementById('current-variant-' + optionId)?.innerText;
        let productUrl = variant?`${url}?variant=${variant}&section_id=${this.sectionId}`:`${url}?section_id=${this.sectionId}`;
        productUrl = productUrl.replace(/\s+/g, '');
        this.activeProductUrl = productUrl;

        if (this.cachedResults[productUrl]) {
          this.renderContent(this.cachedResults[productUrl]);
          this.loading = false;
          return true;
        }

        if (this.cachedfetch[productUrl]) return true;

        this.cachedfetch[productUrl] = true;
        fetch(productUrl)
          .then(reponse => {
            if (!reponse.ok) throw new Error('Quick view could not be loaded');
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const source = parser.parseFromString(response,'text/html').getElementById("quickview-product-content");
            if (!source) throw new Error('Quick view content is missing');
            const deferredContent = source.querySelector('template[data-quickview-content]');
            const content = deferredContent ? deferredContent.innerHTML : source.innerHTML;
            this.cachedResults[productUrl] = content;
            if (this.activeProductUrl === productUrl && this.show) {
              this.renderContent(content);
            }
          })
          .catch((error) => {
            console.error('Quick view loading error:', error);
            if (this.activeProductUrl === productUrl && this.show) {
              this.loadError = true;
            }
          })
          .finally(() => {
            if (this.activeProductUrl === productUrl) this.loading = false;
            this.cachedfetch[productUrl] = false;
          });

        return true;
      },
      async loadChooseOptions(url, el, optionId, index) {
        setTimeout(async () => {
          this.chooseOptionsError = false;
          let getVariant = document.getElementById('current-variant-' + optionId)?.innerText;
          let urlProduct = getVariant?`${url}?variant=${getVariant}&section_id=choose-option&page=${index}`:`${url}?section_id=choose-option&page=${index}`;
          
          let destinationElm = document.getElementById('choose-options-' + optionId)?.querySelector('.choose-options');
          let destinationElmMobile = document.getElementById('choose-options-mobile');
          let loadingEl = document.getElementById('choose-options-' + optionId)?.querySelector('.icon-loading');
          
          if (this.loadedChooseOptions[urlProduct]) {
            if (window.innerWidth > 767) {
              if (!el.closest('.card-product').querySelector('#choose-options-' + optionId)?.querySelector('.choose-options-content')) {
                destinationElm && (destinationElm.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElmMobile && (destinationElmMobile.innerHTML = '');  
              }
            } else {
              if (!el.closest('.card-product').querySelector('#choose-options-mobile')) {
                destinationElmMobile && (destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElm && (destinationElm.innerHTML = '');
              }
            }
            return true;
          }
          
          try {
            if (loadingEl) {
              loadingEl.classList.remove('hidden');
            }
            this.loadingChooseOption = true;
            if (!this.loadingUrls.includes(urlProduct)) {
              this.loadingUrls.push(urlProduct);
              await fetch(urlProduct).then((response) => {
                if (!response.ok) throw new Error('Product options could not be loaded');
                return response.text();
              }).then((content) => {
                const parser = new DOMParser();
                const source = parser.parseFromString(content, 'text/html').getElementById("choose-options-content");
                if (!source) throw new Error('Product options are missing');
                const parsedContent = source.innerHTML;
                
                if (parsedContent) {
                  if (window.innerWidth > 767) {
                    destinationElmMobile && (destinationElmMobile.innerHTML = '');
                    destinationElm && (destinationElm.innerHTML = parsedContent);
                  } else {
                    destinationElmMobile && (destinationElmMobile.innerHTML = parsedContent);
                    destinationElm && (destinationElm.innerHTML = '');
                  }
                  this.loadedChooseOptions[urlProduct] = parsedContent;
                }
                if (loadingEl) {
                  loadingEl.classList.add('hidden');
                }  
              }).finally(() => {
                const index = this.loadingUrls.indexOf(urlProduct);
                if (index !== -1) this.loadingUrls.splice(index, 1);  
                if (window.innerWidth > 767) {
                  if (destinationElm) {
                    if (destinationElm.querySelector(".add_to_cart_button")) {
                      destinationElm.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElm.querySelector(".label-btn-quickview")) {
                      destinationElm.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                } else {
                  if (destinationElmMobile) {
                    if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                      destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                      destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                }      
              });
            }
          } catch (error) {
            console.error('Product options loading error:', error);
            this.chooseOptionsError = true;
          } finally {
            if (loadingEl) loadingEl.classList.add('hidden');
            this.loadingChooseOption = false;
          }
        }, 0)
      },
      retryLoad() {
        if (!this.pendingLoad) return;
        if (this.activeProductUrl) this.cachedfetch[this.activeProductUrl] = false;
        this.loadError = false;
        this.loadPending();
      },
      open(isMiniCart = false) {
        const opener = this.pendingLoad?.el || document.activeElement;
        if (opener && typeof opener.focus === 'function') this.buttonQuickView = opener;
        this.show = true;
        this.loadError = false;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
        this.loadPending();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.focusQuickView('QuickView', 'QuickViewClose'));
        });
      },
      close(restoreFocus = true) {
        const opener = this.buttonQuickView;
        this.deactivateFocusTrap('quickView');
        this.show = false;
        this.loading = false;
        this.loadError = false;
        this.buttonQuickView = null;
        this.pendingLoad = null;
        this.activeProductUrl = '';
        if(!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
        if (restoreFocus) this.restoreFocus(opener);
      },
      focusQuickView(quickView, btnClose) {
        if (!this.selected && this.show) this.activateFocusTrap(quickView, btnClose, 'quickView');
      },
      removeFocusQuickView() {
        const opener = this.buttonQuickView;
        this.deactivateFocusTrap('quickView');
        if (!this.selected) this.restoreFocus(opener);
      },
      focusChooseOptions() {
        if (!this.openPopupMobile || window.innerWidth > 767) return;
        this.activateFocusTrap('ChooseOptionsMobileDialog', 'ChooseOptionsMobileClose', 'chooseOptions');
      },
      closePopupMobile(restoreFocus = true) {
        const opener = this.chooseOptionsTrigger;
        this.deactivateFocusTrap('chooseOptions');
        this.openPopupMobile = false;
        this.chooseOptionsError = false;
        this.chooseOptionsTrigger = null;
        if (restoreFocus) this.restoreFocus(opener);
      },
      showChooseOption(id, el) {
        this.chooseOptionsTrigger = el;
        this.chooseOptionsError = false;
        this.openPopupMobile = true;
        const product = el.closest(".card-product");
        const addToCartBtn = product.querySelector('.choose-options')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options')?.querySelector('.label-btn-quickview')
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.label-btn-quickview')

        if(addToCartBtn && iconAddToCartBtn && window.innerWidth > 767){
          addToCartBtn.style.display="block"
          iconAddToCartBtn.style.display="none"
        }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
          addToCartBtnMobile.style.display="block"     
          iconAddToCartBtnMobile.style.display="none"
        }

        if (window.innerWidth <= 767) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => this.focusChooseOptions());
          });
        }
      },
      clickInsideQuickView(evt, $el) {
        if(this.isMiniCart) {
          evt.stopPropagation();
          this.close();
        }
      },
      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      }
    });
  });
});
